import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { 
    selectCompany, 
    selectLanguage, 
    selectUserId, 
    selectBankName,
    selectBik,
    selectCheckingAccount,
    selectCorrespondentAccount,
    selectInn,
    selectKpp,
    setCompany, 
    setLanguage,
    setBankName,
    setBik,
    setCheckingAccount,
    setCorrespondentAccount,
    setInn,
    setKpp
} from '../Login/loginSlice';
import { sendSettings } from '../Login/loginApi';
import { texts } from '../Common/common';
import './Settings.css';

const languages = [
    { label: 'Русский', value: 'ru' },
    { label: 'English', value: 'en' },
    { label: '中文', value: 'zh' },
    { label: 'Português', value: 'pt' },
    { label: 'Español', value: 'es' },
];

const Settings = () => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(selectLanguage);
    const company = useSelector(selectCompany);
    const bankName = useSelector(selectBankName);
    const bik = useSelector(selectBik);
    const checkingAccount = useSelector(selectCheckingAccount);
    const correspondentAccount = useSelector(selectCorrespondentAccount);
    const inn = useSelector(selectInn);
    const kpp = useSelector(selectKpp);
    const user_id = useSelector(selectUserId);
    const [selectedLanguage, setSelectedLanguage] = useState(currentLanguage);
    const [modalVisible, setModalVisible] = useState(false);

    const handleSave = () => {
        dispatch(setLanguage(selectedLanguage));
        setModalVisible(false);

        sendSettings({
            user_id,
            company_name: company || '',
            language: selectedLanguage,
            bank_name: bankName || '',
            bik: bik || '',
            checking_account: checkingAccount || '',
            correspondent_account: correspondentAccount || '',
            inn: inn || '',
            kpp: kpp || ''
        }).then((data) => {
            console.log('Настройки успешно отправлены:', data);
        }).catch((error) => {
            console.error('Ошибка при отправке настроек:', error);
        });
    };

    const handleLanguageSelect = (value) => {
        setSelectedLanguage(value);
        setModalVisible(false);
    };

    return (
        <div className="settings-container">
            <div className="settings-form">
                <div className="settings-row">
                    <div className="settings-field settings-field-right">
                        <label className="settings-label">
                            {texts[currentLanguage]?.company || 'Компания'}
                        </label>
                        <input
                            type="text"
                            className="settings-input"
                            value={company || ''}
                            onChange={(e) => dispatch(setCompany(e.target.value))}
                            placeholder="ООО ..."
                            autoCapitalize="sentences"
                        />
                    </div>

                    <div className="settings-field">
                        <label className="settings-label">
                            {texts[currentLanguage]?.language || 'Язык'}
                        </label>
                        <button
                            className="settings-select-button"
                            onClick={() => setModalVisible(true)}
                        >
                            <span className="settings-selected-value">
                                {languages.find(lang => lang.value === selectedLanguage)?.label || 'Русский'}
                            </span>
                        </button>
                    </div>
                </div>

                <div className="settings-section-divider">
                    <span className="settings-section-divider-text">Реквизиты</span>
                </div>

                <div className="settings-field settings-field-full-width">
                    <label className="settings-label">Название банка</label>
                    <input
                        type="text"
                        className="settings-input"
                        value={bankName || ''}
                        onChange={(e) => dispatch(setBankName(e.target.value))}
                        placeholder="АО &quot;Банк&quot;"
                        autoCapitalize="sentences"
                    />
                </div>

                <div className="settings-row">
                    <div className="settings-field settings-field-right settings-field-flex-60">
                        <label className="settings-label">Расчётный счёт</label>
                        <input
                            type="text"
                            className="settings-input"
                            value={checkingAccount || ''}
                            onChange={(e) => dispatch(setCheckingAccount(e.target.value))}
                            placeholder="40702810..."
                            inputMode="numeric"
                        />
                    </div>
                    <div className="settings-field settings-field-flex-40">
                        <label className="settings-label">БИК</label>
                        <input
                            type="text"
                            className="settings-input"
                            value={bik || ''}
                            onChange={(e) => dispatch(setBik(e.target.value))}
                            placeholder="123456789"
                            inputMode="numeric"
                        />
                    </div>
                </div>

                <div className="settings-field settings-field-full-width">
                    <label className="settings-label">Корреспондентский счёт</label>
                    <input
                        type="text"
                        className="settings-input"
                        value={correspondentAccount || ''}
                        onChange={(e) => dispatch(setCorrespondentAccount(e.target.value))}
                        placeholder="30101810..."
                        inputMode="numeric"
                    />
                </div>

                <div className="settings-row">
                    <div className="settings-field settings-field-right">
                        <label className="settings-label">ИНН</label>
                        <input
                            type="text"
                            className="settings-input"
                            value={inn || ''}
                            onChange={(e) => dispatch(setInn(e.target.value))}
                            placeholder="7700000000"
                            inputMode="numeric"
                        />
                    </div>
                    <div className="settings-field">
                        <label className="settings-label">КПП</label>
                        <input
                            type="text"
                            className="settings-input"
                            value={kpp || ''}
                            onChange={(e) => dispatch(setKpp(e.target.value))}
                            placeholder="770001001"
                            inputMode="numeric"
                        />
                    </div>
                </div>

                <button
                    className="settings-save-button"
                    onClick={handleSave}
                >
                    {texts[currentLanguage]?.save || 'Сохранить'}
                </button>
            </div>

            {/* Модальное окно для выбора языка */}
            {modalVisible && (
                <div className="settings-modal-overlay" onClick={() => setModalVisible(false)}>
                    <div className="settings-modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="settings-modal-header">
                            <h3>{texts[currentLanguage]?.language || 'Выберите язык'}</h3>
                            <button
                                className="settings-modal-close"
                                onClick={() => setModalVisible(false)}
                            >
                                ✕
                            </button>
                        </div>
                        <div className="settings-language-list">
                            {languages.map((item) => (
                                <button
                                    key={item.value}
                                    className={`settings-language-option ${selectedLanguage === item.value ? 'active' : ''}`}
                                    onClick={() => handleLanguageSelect(item.value)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Settings;